import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot,ActivatedRoute } from '@angular/router';
import { WorkgroupService } from './workgroup.service';
import { AssociateService } from '../../shared/services/associate.service';
@Injectable()
export class getWorkGroupResolver implements Resolve<any> {
    constructor(private service: WorkgroupService,
        private activeroute: ActivatedRoute) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.service.getWorkGroup(route.params['id']);
    }
}

@Injectable()
export class getWorkGroupsResolver implements Resolve<any> {
    constructor(private service: WorkgroupService,
        private activeroute: ActivatedRoute) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.service.getWorkGroup();
    }
}

@Injectable()
export class getAssociatesResolver implements Resolve<any> {
    constructor(private service: AssociateService) { }

    // without it returen empty resolve.....
    getServiceData(): Promise<any> {
        return new Promise(resolve => {
            this.service.getAllAssociates(0 , 50).subscribe( res => {
                resolve( res);
            }, (error) => {
                resolve (error);
            });
        });
    }
    resolve(route: ActivatedRouteSnapshot) {
        return this.getServiceData();
    }
}